import React, { useEffect } from 'react'
import { DashboardAverageResponseTime, DashboardClosedTicketsIcon, DashboardOpenTicketsIcon, DashboardOverallRepsonseTime, DashboardResponseTimeInfoIcon, DashboardTotalTicketsIcon, EditProfileDarkIcon } from '../../icon'
import { Grid, Tooltip, Zoom } from '@mui/material'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useState } from 'react'
import StaticticsBarGraph from './statitics.component'
import { ChannelUserService } from '../../services/ChannelUserService'
import { ChannelUserModel } from '../../models/users.model'
import DashBoardHeroIcon from '../../icons/dashboard-hero-icon.svg'
import { Role } from '../../models/roles.model'
import { setHeaderTitle } from '../../helpers/header.helper'
import { UtilityService } from '../../services/UtilityService'
import AnimateLoaderComponent from "../shared/loaders/animate-loader.component";
import DashBoardCardLoader from "../shared/loaders/dasboard-ticket-card-loader-animation.json";
import DashBoardGraphLoader from "../shared/loaders/dashboard-graph-animation.json";
import { pageTitles } from '../shared/constants'
import PageHeader from "../shared/page-header.component";
import RatingStaticsComponent from './rating-statics.component'
import { ChatRatingModel, mapToChatRatingModel, mapToOnboardingDetailsModel, OnboardingDetailsModel } from '../../models/dashboard.model'
import ConversationCardLoaderAminationData from "../shared/loaders/conversations-card-loader.json";
import { ChannelConversationCardModel, ChannelConversationItem, ChannelConversationStatus } from '../../models/conversations'
import ConversationCardsComponent from '../conversations/conversation-cards.component'
import { range } from 'lodash'
import { ChannelAccountModel } from '../../models/channels/channels.model'
import BlankConvCard from '../conversations/blank-conversation-tab'
import OnboardingCheckPoints from './onboarding-component'
import { AppRoutes } from '../routes/route.path';
import { updateOnBoardingDetails } from '../../reducers/reducer';



const DashboardViewComponent: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const IsMobileDevice = useSelector(selector.isMobileDevice)
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const ChannelConversations: ChannelConversationItem[] = useSelector(selector.ChannelConversations);
    const ChannelTemplates = useSelector(selector.ChannelTemplates);
    const LoadingConversations: boolean = useSelector(selector.LoadingConnect);
    const [convCardsData, setConvCardsData] = useState<ChannelConversationCardModel[]>([])
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const OnboardingDetails: OnboardingDetailsModel = useSelector(selector.OnboardingDetails);

    const [days, setDays] = useState<number>(1)
    const [firstResponseTime, setFirstResponseTime] = useState<string>("0")
    const [totalResponseTime, setTotalResponseTime] = useState<string>("0")
    const [ticketMetrics, setTicketMetrics] = useState<any>([])
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [chatRating, setChatRating] = useState<ChatRatingModel>()

    useEffect(() => {
        setConvCardsData(ChannelConversations.map(data => ({ ...data, IsActive: false })).filter(x => x.Status !== ChannelConversationStatus.CONVERSATION_DELETED).filter(x => x.Status !== ChannelConversationStatus.LIVECHAT_USER_CREATED).sort((a, b) => new Date(a.MessageDateTime) > new Date(b.MessageDateTime) ? -1 : 1).slice(0, 10) as ChannelConversationCardModel[])
    }, [ChannelConversations])


    useEffect(() => {
        const dates = generateDays(days);
        const mergedData = mergeDataWithDates(dates, ticketMetrics);
        setData(mergedData);
    }, [ticketMetrics]);

    useEffect(() => {
        setHeaderTitle("Dashboard")
        setIsLoading(true)
        ChannelUserService.getDashboardMetrics(CurrentUser.OrganizationID, days).then((res) => {
            setIsLoading(false)
            setFirstResponseTime(secondsToMinutes(res.data.response_time.first_response_time));
            setTotalResponseTime(secondsToMinutes(res.data.response_time.total_response_time));
            setTicketMetrics(res.data.ticket_metrics);
            setChatRating(mapToChatRatingModel(res.data.outgoing_rating))
        }).catch(() => {
            setIsLoading(false)
        })
    }, [days])

    const secondsToMinutes = (seconds) => {
        const minutes = Math.floor(seconds);
        const remainingSeconds = Math.floor((seconds * 60) % 60);
        return `${minutes} min ${remainingSeconds} sec`;
    }

    const ticketCount = (countType) => {
        let count = 0
        if (countType === "opened") {
            data?.map(x => count = x?.opened_count + count)
        }
        if (countType === "closed") {
            data?.map(x => count = x?.closed_count + count)
        }
        if (countType === "following") {
            data?.map(x => count = x?.following_count + count)
        }
        if (countType === "total") {
            data?.map(x => count = x?.total_count + count)
        }
        return count
    }

    const handleDaysChange = (value) => {
        setDays(value.Value)
    }

    const DayOptions = [{ Name: "Today", Value: 1 }, { Name: "1 Week", Value: 7 }, { Name: "1 Month", Value: 30 }]

    const transformDataToDict = (data) => {
        const dataDict = {};
        data?.forEach(item => {
            dataDict[item.date] = item;
        });
        return dataDict;
    };

    const generateDays = (count) => {
        const today = new Date();
        const dates = [];
        for (let i = count - 1; i >= 0; i--) {
            const date = new Date(today);
            date.setDate(today.getDate() - i);
            dates.push(date.toISOString().split('T')[0]); // Format date as YYYY-MM-DD
        }
        return dates;
    };


    const mergeDataWithDates = (dates, data) => {
        const dataDict = transformDataToDict(data);
        return dates.map(date => {
            return dataDict[date] || { date, opened_count: 0, closed_count: 0, following_count: 0, total_count: 0 };
        });
    };

    const handleOnboardingDetailsClose = () => {
        ChannelUserService.updateOnBoardingDetails({
            orgId: CurrentUser.OrganizationID, onboardingStatus: false, checkpoints: OnboardingDetails.CheckPoints.map(x => { return { title: x.Title, status: x.Status } })
        }).then((res) => {
            dispatch(updateOnBoardingDetails(mapToOnboardingDetailsModel(res.data)))
        })
    }

    return (
        <div className={`d-flex justify-center w-p-100 h-p-100 ${IsMobileDevice ? "py-1 flex-direction" : ""}`}>
            {IsMobileDevice && <Grid item xs={12} className='w-p-98 mx-auto'>
                <PageHeader
                    Reload={() => { }}
                    HeaderText={pageTitles.DASHBOARD}
                    HideSearch={true}
                    ShowFilterIcon={false} />
            </Grid>}
            <div className={`d-flex flex-direction o-x-hidden pt-2 w-p-100 h-p-100 o-y-scroll ${IsMobileDevice ? " " : "px-4"}`}>
                <div className={`d-flex ${IsMobileDevice ? "px-2 flex-direction" : "w-p-100 h-p-60"}`}>
                    <div className={`falkon-chat-dashboard-banner d-flex ${IsMobileDevice ? "h-24 w-p-100 py-2 justify-between" : `min-h-42 h-p-100 ${(CurrentUser?.RoleID === Role.ORGANIZATION_ADMIN && OnboardingDetails.OnboardingStatus) ? "w-p-60 mr-4" : "w-p-100"}`} br-4`}>
                        <div className={`d-flex flex-direction justify-center ${IsMobileDevice ? "pl-2" : !OnboardingDetails.OnboardingStatus ? "pl-8 w-p-60" : "pl-6 w-p-50"}`}>
                            <div className={`falkon-chat-admin-preview d-flex justify-center align-center color-import-contacts-outlook-border dashboard-user-preview-spacing ${IsMobileDevice ? "footnote-medium br-4 h-3 w-14" : "br-5 footnote-medium h-3 px-1 min-w-12"}`}>
                                {`${CurrentUser.RoleID === Role.ORGANIZATION_ADMIN ? "ADMIN" : CurrentUser.RoleID === Role.MANAGER ? "MANAGER" : "AGENT"} PREVIEW`}
                            </div>
                            <div className={`color-import-contacts-outlook-border mt-2 ${IsMobileDevice ? "h4-semibold" : "h1-semibold"}`}>
                                Hi {CurrentUser.FullName},
                            </div>
                            <div className={`color-primary-accent ${IsMobileDevice ? "h5-medium" : "h1-medium"}`}>
                                Welcome to Falkon Chat
                            </div>
                            <div className={`${IsMobileDevice ? "mt-2 px-1 w-12 h5-medium h-3" : "mt-4 px-2 py-1 min-w-14 h4-regular"} br-1  box-shadow-edit-profile d-flex justify-center align-center c-pointer bg-color-secondary`} onClick={() => { navigate(AppRoutes.PROFILE, { state: true }) }} >
                                <EditProfileDarkIcon className='mr-1' /> Edit Profile
                            </div>
                        </div>
                        <div className={`d-flex align-center flex-1 ${IsMobileDevice ? "h-p-100 pr-2" : "h-p-100 pr-4"}`}>
                            <img src={DashBoardHeroIcon} className={`${OnboardingDetails.OnboardingStatus ? "w-p-90 h-p-100" : IsMobileDevice ? "w-p-100 h-p-100" : "h-p-70"}`} />
                        </div>
                    </div>
                    {CurrentUser?.RoleID === Role.ORGANIZATION_ADMIN && OnboardingDetails.OnboardingStatus &&
                        <OnboardingCheckPoints Classname={`${IsMobileDevice ? "mt-3" : "min-h-42"}`} CheckPoints={OnboardingDetails.CheckPoints} Close={handleOnboardingDetailsClose} />
                    }
                </div>
                {!IsMobileDevice && <div className='d-flex h-10 w-p-100'>
                    <div className={`d-flex align-center h-p-100 w-p-60 mr-4`}>
                        {DayOptions.map(x => {
                            return (
                                <div className={`h-4 br-4 d-flex align-center px-2 h5-medium mr-2 c-pointer ${x.Value === days ? "bg-color-primary-light color-secondary" : "selected-card-filter-options bg-color-nav-bar"}`} onClick={() => handleDaysChange(x)}>{x.Name}</div>
                            )
                        })}
                    </div>
                    <div className={`d-flex align-center flex-1 h-10 w-p-100 mr-4 h1-semibold`}>
                        Recent Conversations
                    </div>
                </div>
                }
                <div className={`d-flex ${IsMobileDevice ? "flex-direction" : "min-h-40 w-p-100"}`}>
                    {IsMobileDevice && <div className='d-flex h-10 w-p-100 pl-2 mt-2'>
                        <div className={`d-flex align-center h-p-100 w-p-100 mr-4`}>
                            {DayOptions.map(x => {
                                return (
                                    <div className={`h-4 br-4 d-flex align-center px-2 h5-medium mr-2 c-pointer ${x.Value === days ? "bg-color-primary-light color-secondary" : "selected-card-filter-options bg-color-nav-bar"}`} onClick={() => handleDaysChange(x)}>{x.Name}</div>
                                )
                            })}
                        </div>
                    </div>
                    }
                    <div className={`d-flex flex-direction  ${IsMobileDevice ? "px-2" : "w-p-60 mr-4 min-h-40 h-p-100"}`}>
                        {isLoading ?
                            < AnimateLoaderComponent LoaderAnimation={DashBoardCardLoader} className={"flex-1 mr-3"} />
                            :
                            <>
                                <div className={`d-flex color-primary-accent w-p-100 flex-1 ${IsMobileDevice ? "mb-1 h-12" : "mb-3"}`}>
                                    <div className={`flex-1 br-2 ${IsMobileDevice ? "h-p-100 mr-1" : "h4-semibold h-p-100 mr-3"}  bg-color-channel-dashboard-total-tickets d-flex`}>
                                        <div className={`d-flex justify-center align-center ${IsMobileDevice ? "w-4" : "w-10 h-10 br-p-50 my-auto"} px-1`}>
                                            <DashboardTotalTicketsIcon className={`${IsMobileDevice ? "" : "w-8 h-8"}`} />
                                        </div>
                                        <div className='flex-1 h-p-100 d-flex flex-direction align-flex-start justify-center'>
                                            <div className={`${IsMobileDevice ? "h5-medium" : "h5-semibold"} color-channel-dashboard-total-tickets-header`}>All Chats</div>
                                            <div className={`${IsMobileDevice ? "h3-semibold" : "dashboard-sms-heading"}`}>
                                                {ticketCount("total")}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`flex-1 br-2 ${IsMobileDevice ? "h-p-100 mr-1" : "h4-semibold h-p-100 mr-3"}  bg-color-channel-dashboard-open-tickets d-flex`}>
                                        <div className={`d-flex justify-center align-center ${IsMobileDevice ? "w-4" : "w-10 h-10 br-p-50 my-auto"} px-1`}>
                                            <DashboardOpenTicketsIcon className={`${IsMobileDevice ? "" : "w-8 h-8"}`} />
                                        </div>
                                        <div className='flex-1 h-p-100 d-flex flex-direction align-flex-start justify-center'>
                                            <div className={`${IsMobileDevice ? "h5-medium" : "h5-semibold"} color-channel-dashboard-open-tickets-header`}>Open chats</div>
                                            <div className={`${IsMobileDevice ? "h3-semibold" : "dashboard-sms-heading"}`}>
                                                {ticketCount("opened")}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`flex-1 br-2 ${IsMobileDevice ? "h-p-100" : "h4-semibold h-p-100"}  bg-color-channel-dashboard-closed-tickets d-flex`}>
                                        <div className={`d-flex justify-center align-center ${IsMobileDevice ? "w-4" : "w-10 h-10 br-p-50 my-auto"} px-1`}>
                                            <DashboardClosedTicketsIcon className={`${IsMobileDevice ? "" : "w-8 h-8"}`} />
                                        </div>
                                        <div className='flex-1 h-p-100 d-flex flex-direction align-flex-start justify-center'>
                                            <div className={`${IsMobileDevice ? "h5-medium" : "h5-semibold"} color-channel-dashboard-closed-tickets-header`}>Closed chats</div>
                                            <div className={`${IsMobileDevice ? "h3-semibold" : "dashboard-sms-heading"}`}>
                                                {ticketCount("closed")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex color-primary-accent w-p-100 flex-1'>
                                    <div className={`br-2 h-p-100 flex-1 h5-semibold bg-color-channel-dashboard-average-response-time d-flex ${IsMobileDevice ? "mr-1 min-h-12" : "mr-3"}`}>
                                        <div className={`d-flex justify-center align-center ${IsMobileDevice ? "w-4" : "w-10 h-10 br-p-50 my-auto"} px-1`}>
                                            <DashboardAverageResponseTime className='w-8 h-8' />
                                        </div>
                                        <div className='flex-1 h-p-100 d-flex flex-direction align-flex-start justify-center'>
                                            <div className='h5-medium color-channel-dashboard-average-response-time-header'>
                                                Average first response time
                                            </div>
                                            <div className={`${IsMobileDevice ? "h4-semibold" : "h1-semibold"}`}>
                                                {firstResponseTime}
                                                <span className='ml-1'><Tooltip title="The average time an agent takes to reply to a visitor's initial query. Faster response times mean quicker support and higher customer satisfaction." placement='top-end' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index w-40" }} className='ml-auto'>
                                                    <DashboardResponseTimeInfoIcon className={`${IsMobileDevice ? "w-2" : "w-2 h-2"} c-pointer`} />
                                                </Tooltip></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`br-2 h-p-100 flex-1 h5-semibold bg-color-channel-dashboard-average-response-time d-flex ${IsMobileDevice && "min-h-12"}`}>
                                        <div className={`d-flex justify-center align-center ${IsMobileDevice ? "w-4" : "w-10 h-10 br-p-50 my-auto"} px-1`}>
                                            <DashboardOverallRepsonseTime className='w-8 h-8' />
                                        </div>
                                        <div className='flex-1 h-p-100 d-flex flex-direction align-flex-start justify-center'>
                                            <div className='h5-medium color-channel-dashboard-average-response-time-header'>
                                                Average response time
                                            </div>
                                            <div className={`${IsMobileDevice ? "h4-semibold" : "h1-semibold"}`}>
                                                {totalResponseTime}
                                                <span className='ml-1'><Tooltip title="The average time an agent takes to respond to each of the visitor's queries. Faster response times mean quicker support and higher customer satisfaction." placement='top-end' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }} className='ml-auto'>
                                                    <DashboardResponseTimeInfoIcon className={`${IsMobileDevice ? "w-2" : "w-2 h-2"} c-pointer`} />
                                                </Tooltip></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    {IsMobileDevice && <div className='d-flex h-6 w-p-100 my-2 pl-2'>
                        <div className={`d-flex align-center flex-1 h-10 w-p-100 mr-4 h3-semibold`}>
                            Recent Conversations
                        </div>
                    </div>}
                    <div className={`flex-1 d-flex flex-direction ${IsMobileDevice ? "px-1" : "o-y-scroll min-h-40 h-p-100"}`}>
                        {LoadingConversations ?
                            range(10).map(x => {
                                return (
                                    <AnimateLoaderComponent LoaderAnimation={ConversationCardLoaderAminationData} className={"conv-card-border p-0 m-0"} />
                                )
                            })
                            :
                            !!convCardsData?.length ?
                                convCardsData.map((carddata, index) => {
                                    return (
                                        <ConversationCardsComponent data={carddata} style={undefined} index={index} onClick={() => {
                                            navigate(IsTeamsApp ? `/teams/conversations/${carddata.ID}` : `/conversations/${carddata.ID}`)
                                        }} />
                                    )
                                })
                                :
                                <BlankConvCard label={""} />
                        }
                    </div>
                </div>
                <div className='d-flex w-p-100 my-4'>
                    {isLoading ?
                        < AnimateLoaderComponent LoaderAnimation={DashBoardGraphLoader} className={"w-p-100"} />
                        :
                        <div className={`box-shadow-channel w-p-100 min-h-50 d-flex flex-direction ${IsMobileDevice && "mx-2"}`}>
                            <div className='w-p-100 h-p-20 d-flex '>
                                <div className={`min-w-28 d-flex justify-center align-center h-p-100 w-space ${IsMobileDevice ? "h3-semibold ml-3" : "h4-semibold"}`}>
                                    Overall Ticket Statistics
                                </div>
                                {!IsMobileDevice && <div className='min-w-28 d-flex justify-center align-center'>
                                    <div className='w-p-50 h-p-100 d-flex justify-center align-center'>
                                        <div className='open-tickets mr-1'></div>
                                        <div className='footnote-semibold w-space'>Open Tickets</div>
                                    </div>
                                    <div className='w-p-50 h-p-100 d-flex justify-center align-center'>
                                        <div className='closed-tickets mr-1'></div>
                                        <div className='footnote-semibold w-space'>Closed Tickets</div>
                                    </div>
                                </div>
                                }
                            </div>
                            <StaticticsBarGraph
                                Stacked={IsMobileDevice}
                                Data={data?.map(x => { return { date: UtilityService.convertToDay(x?.date).slice(0, 6), OpenTickets: x?.opened_count, ClosedTickets: x?.closed_count } })}
                                Bottom_Color_Details_Hide={true}
                                Horizontal_Lines={true}
                                Hide_YAxisLine={true}
                                Hide_XAxisLine={true}
                                Bar_one={{ backgroundColor: "#007AEA", name: "Open Tickets" }}
                                Bar_two={{ backgroundColor: "#E84864", name: "Closed Tickets" }}
                            />
                            {IsMobileDevice && <div className={`min-w-28 d-flex justify-center align-center mx-auto my-2`}>
                                <div className='w-p-50 h-p-100 d-flex justify-center align-center mr-2'>
                                    <div className='open-tickets mr-1'></div>
                                    <div className='h6-semibold w-space'>Open Tickets</div>
                                </div>
                                <div className='w-p-50 h-p-100 d-flex justify-center align-center'>
                                    <div className='closed-tickets mr-1'></div>
                                    <div className='h6-semibold w-space'>Closed Tickets</div>
                                </div>
                            </div>
                            }
                        </div>
                    }
                </div>
                {
                    isLoading ?
                        < AnimateLoaderComponent LoaderAnimation={DashBoardGraphLoader} className={"w-p-100  py-2"} />
                        :
                        <div className={`box-shadow-channel d-flex flex-direction ${IsMobileDevice && "mx-2"}`}>
                            <div className='h4-medium px-5 py-3'>
                                <div className='h4-medium mb-2'> Reviews overview</div>
                                <div className={`d-flex justify-between ${IsMobileDevice ? "w-p-100" : "w-p-33"}`} >
                                    <div>
                                        <div className='h1-semibold'>{chatRating?.TotalReviews}</div>
                                        <div className='h5-medium'>Total reviews</div>
                                    </div>
                                    <div>
                                        <div className='h1-semibold'>{chatRating?.AvgRating}</div>
                                        <div className='h5-medium'>Average rating</div>
                                    </div>
                                </div>
                            </div>

                            <RatingStaticsComponent
                                Data={[{ name: '1 Star', Users: chatRating?.OneStar, opacity: 0.26 },
                                { name: '2 Stars', Users: chatRating?.TwoStar, opacity: 0.39 },
                                { name: '3 Stars', Users: chatRating?.ThreeStar, opacity: 0.45 },
                                { name: '4 Stars', Users: chatRating?.FourStar, opacity: 0.71 },
                                { name: '5 Stars', Users: chatRating?.FiveStar, opacity: 1 },
                                ]}
                            />
                        </div>

                }
                <div className={`w-p-100  bg-color-secondary mt-4 ${IsMobileDevice ? "min-h-4" : "min-h-1"}`}>
                </div>
            </div>
        </div >
    )
}

export default DashboardViewComponent